var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpencv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,43c-5.514,0 -10,-4.486 -10,-10c0,-3.562 1.916,-6.88 5,-8.66l3,5.196c-1.233,0.712 -2,2.039 -2,3.464c0,2.168 1.832,4 4,4c2.168,0 4,-1.832 4,-4c0,-1.425 -0.767,-2.752 -2,-3.464l3,-5.196c3.084,1.78 5,5.099 5,8.66c0,5.514 -4.486,10 -10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,22.629l-3,-5.196c1.233,-0.712 2,-2.04 2,-3.464c0,-2.168 -1.832,-4 -4,-4c-2.168,0 -4,1.832 -4,4c0,1.425 0.767,2.752 2,3.464l-3,5.196c-3.084,-1.781 -5,-5.1 -5,-8.661c0,-5.514 4.486,-10 10,-10c5.514,0 10,4.486 10,10c0,3.562 -1.916,6.881 -5,8.661z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.001,43.028c-3.459,0 -6.827,-1.793 -8.678,-4.997c-2.757,-4.776 -1.115,-10.903 3.66,-13.661c3.085,-1.781 6.917,-1.781 10,0l-3,5.196c-1.234,-0.713 -2.766,-0.713 -4,0c-1.878,1.084 -2.548,3.586 -1.465,5.464c1.084,1.877 3.586,2.549 5.465,1.464c1.233,-0.712 2,-2.04 2,-3.464h6c0,3.561 -1.916,6.879 -5,8.66c-1.57,0.908 -3.288,1.338 -4.982,1.338z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencv);
export default __webpack_public_path__ + "static/media/opencv.e72cdf126d8b5d1cc85ec01210a9d33f.svg";
export { ForwardRef as ReactComponent };